import { authHeaders, handleUnauthorized } from './http';
const BASE = '/api/data-sources';

async function dsRequest<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(init?.headers || {}) },
    ...init,
  });
  handleUnauthorized(res);
  if (!res.ok) {
    const text = await res.text();
    try {
      throw new Error(JSON.stringify(JSON.parse(text)));
    } catch {
      throw new Error(text || res.statusText);
    }
  }
  return res.json();
}

export interface DataSourceCatalogItem {
  id: string;
  name: string;
  api_type: string;
  base_url: string;
  auth: string;
  status: string;
  series_count: number;
  register_url?: string;
}

export interface FetchResult {
  imported: number;
  skipped: number;
  errors: string[];
  fetched?: number;
  source_errors?: string[];
  world_bank_fetched?: number;
  sbp_fetched?: number;
  pbs_note?: string;
}

export interface SourceStatus {
  series: { source: string; variable_id: string; variable_name: string; series: string; description: string; latest: null | { value: number; observation_date: string; source_agency: string; release_date: string | null; note: string | null } }[];
  observations_by_source: Record<string, number>;
  last_fetch: Record<string, { fetched_at: string; imported: number; errors: string[] }>;
  coverage: { core_variables: number; with_data: number; missing: string[] };
}

export const dataSourcesApi = {
  status: () => dsRequest<SourceStatus>('/status'),
  mappings: () => dsRequest<Record<string, any[]>>('/mappings'),
  fetchSource: (source: string) => dsRequest<any>(`/fetch/${source}`, { method: 'POST' }),
  catalog: () => dsRequest<DataSourceCatalogItem[]>('/catalog'),
  pbsLinks: () => dsRequest<{ variable_id: string; portal_url: string; label: string }[]>('/pbs/links'),
  gcubedTemplate: () => dsRequest<Record<string, unknown>>('/gcubed/template'),
  gcubedExamples: () => dsRequest<{ file: string; scenario_id: string; payload: Record<string, unknown> }[]>('/gcubed/examples'),
  fetchWorldBank: () => dsRequest<FetchResult>('/fetch/world-bank', { method: 'POST' }),
  fetchSbp: () => dsRequest<FetchResult>('/fetch/sbp-easydata', { method: 'POST' }),
  fetchAll: () => dsRequest<FetchResult>('/fetch/all', { method: 'POST' }),
  fetchLog: () => dsRequest<{ source: string; imported: number; errors: string; fetched_at: string }[]>('/fetch-log'),
  importGcubed: (body: Record<string, unknown>) =>
    dsRequest<{ id: string; status: string }>('/gcubed/import', { method: 'POST', body: JSON.stringify(body) }),
};
